import type { CustomerMapping, CustomerMappingInput } from '@/types/customerMapping';
import apiClient from './axios';

export async function fetchCustomerMappings(): Promise<CustomerMapping[]> {
  const { data } = await apiClient.get<CustomerMapping[]>('/customer-mappings', { skipGlobalError: true });
  return data;
}

export async function createCustomerMapping(input: CustomerMappingInput): Promise<CustomerMapping> {
  const { data } = await apiClient.post<CustomerMapping>('/customer-mappings', input, { skipGlobalError: true });
  return data;
}

export async function updateCustomerMapping(id: string, input: Partial<CustomerMappingInput>): Promise<CustomerMapping> {
  const { data } = await apiClient.patch<CustomerMapping>(`/customer-mappings/${id}`, input, { skipGlobalError: true });
  return data;
}

export async function deleteCustomerMapping(id: string): Promise<void> {
  await apiClient.delete(`/customer-mappings/${id}`, { skipGlobalError: true });
}
